import { Id, QueryParams } from "PFTypes";

export const shortlistsKeys = {
  all: () => ["shortlists"],
  activityShortlists: (activityId: Id, params?: QueryParams) => [
    ...shortlistsKeys.all(),
    String(activityId),
    ...(params ? [params] : [])
  ],
  activitySuspendedShortlists: (activityId: Id, params?: QueryParams) => [
    ...shortlistsKeys.all(),
    "suspended",
    String(activityId),
    ...(params ? [params] : [])
  ]
};

export const rankedShortlistsKeys = {
  all: () => ["rankedShortlists"],
  activityRankedShortlists: (activityId: Id, profileIds: Id[] = []) => [
    ...rankedShortlistsKeys.all(),
    String(activityId),
    ...profileIds
  ]
};
